// add a text wrapping function to the String.prototype

export default function() {
  // from https://www.30secondsofcode.org/js/s/word-wrap/

  String.prototype.wrap = function (max) {
    return this.replace(
      new RegExp(`(?![^\\n]{1,${max}}$)([^\\n]{1,${max}})\\s`, 'g'), `$1\n`
    )
  }
}
